import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

import { FaQuestionCircle, FaUserTie, FaHome, FaCreditCard } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import './styles.css';

const FAQ = () => {
  const [openSection, setOpenSection] = useState(null);
  const [openQuestion, setOpenQuestion] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  // refs para cada seção
  const sectionRefs = useRef([]);

  const faqSections = [
    {
      title: "Contato e Suporte", 
      icon: <FaQuestionCircle />,
      description: "Dúvidas sobre como entrar em contato e suporte na Joviplanet.",
      questions: [
        {
          question: "Como contactar com a Joviplanet ?",
          answer: "Você pode entrar em contato com a Joviplanet através da página de contato, e-mail de suporte ou pelo chat disponível na plataforma."
        },
        {
          question: "Como enviar mensagem ao agente, empreendedor e ou proprietário ?",
          answer: "Na página do imóvel, clique no botão de contato para enviar uma mensagem diretamente ao agente, empreendedor ou proprietário."
        },
        {
          question: "O que fazer se não receber o mail de ativação do registo de conta ?",
          answer: "Verifique sua caixa de spam/lixo eletrônico. Caso não encontre, solicite o reenvio do e-mail de ativação na tela de login ou entre em contato com o suporte."
        },
        {
          question: "O que fazer se a ficha cliente estiver incompleta ?",
          answer: "Acesse sua área de cliente e complete os dados obrigatórios. Se persistir, entre em contato com o suporte para orientação."
        },
        {
          question: "Problemas técnicos COOKIES e CACHE :",
          answer: "Limpe o cache e os cookies do seu navegador. Se o problema continuar, tente acessar em outro navegador ou dispositivo."
        },
        {
          question: "Como fazer a limpeza do histórico do meu computador ?",
          answer: "Acesse as configurações do seu navegador e selecione a opção para limpar histórico, cookies e cache."
        },
        {
          question: "Phishing; O que fazer ao receber o mail falso da Jopviplanet ?",
          answer: "Não clique em links suspeitos. Encaminhe o e-mail para suporte@joviplanet.com e apague da sua caixa de entrada."
        },
        {
          question: "Qualquer outra questão que tenha e que não encontrou aqui a resposta?",
          answer: (
            <span>
              Não hesite em nos contactar através do <a href="https://joviplanet.com/contacts" target="_blank" rel="noopener noreferrer">FORMULÁRIO DE CONTACTO</a>.
            </span>
          )
        }
      ]
    },
    {
      title: "Pesquisa e Visualização de Imóveis",
      icon: <FaHome />,
      description: "Como pesquisar, visualizar e compartilhar imóveis.",
      questions: [
        {
          question: "Como fazer uma pesquisa na Joviplanet ?",
          answer: "Utilize a barra de pesquisa na página inicial para buscar imóveis por localização, tipo, preço ou outros filtros."
        },
        {
          question: "Como visualizar os imóveis mais recentes ?",
          answer: "Na página de resultados, utilize o filtro de ordenação e selecione 'Mais recentes'."
        },
        {
          question: "Como visualizar os imóveis mais caros ?",
          answer: "No filtro de ordenação, escolha a opção 'Maior preço'."
        },
        {
          question: "Como criar uma lista de favoritos ?",
          answer: "Clique no ícone de coração em cada imóvel para adicioná-lo à sua lista de favoritos."
        },
        {
          question: "Como partilhar um imóvel da lista ?",
          answer: "Na página do imóvel ou na lista de favoritos, utilize o botão de compartilhamento para enviar por e-mail, WhatsApp ou copiar o link."
        },
        {
          question: "Como procurar uma agência imobiliária na minha região ?",
          answer: "Acesse a seção de agências e utilize o filtro de localização para encontrar as mais próximas."
        },
        {
          question: "Qual o limite de imóveis possível de publicar ?",
          answer: "O limite depende do seu plano contratado. Consulte a tabela de planos para mais detalhes."
        },
        {
          question: "Onde posso ver os meus Planos adquiridos, anúncios, mensagens, faturas ?",
          answer: "Essas informações estão disponíveis na sua área de cliente, no painel lateral."
        },
        {
          question: "Pode o cliente anunciar com o seu número de telefone profissional e ou particular ?",
          answer: "Sim, é possível informar ambos os números no cadastro do anúncio."
        },
        {
          question: "Como posso saber o volume de compras e os diferentes tipos de imóveis que foram publicados nos últimos anos ?",
          answer: "Utilize os relatórios disponíveis na área de cliente para visualizar estatísticas e históricos."
        },
        {
          question: "Angariação o que é ?",
          answer: "Angariação é o processo de captação de imóveis para venda ou aluguel, realizado por agentes ou agências."
        },
        {
          question: "Os imóveis são publicados com diferentes portais ?",
          answer: "Sim, a Joviplanet pode integrar anúncios com outros portais parceiros, ampliando a divulgação."
        },
        {
          question: "Como ter o histórico da conversa pelo Chat eletrónico ?",
          answer: "O histórico fica salvo na área de mensagens da sua conta."
        },
        {
          question: "O histórico da conversa pelo o Chat posso pedir durante quando tempo ?",
          answer: "O histórico é mantido por até 12 meses após a última mensagem."
        }
      ]
    },
    {
      title: "Reservas e Anúncios para Férias",
      icon: <FaUserTie />,
      description: "Dúvidas sobre reservas, alterações e cancelamentos em anúncios de férias.",
      questions: [
        {
          question: "Num anúncio para férias, como alterar as datas, após ter enviado o pedido de reserva ?",
          answer: "Entre em contato com o proprietário pelo chat da plataforma e solicite a alteração das datas."
        },
        {
          question: "Num anúncio para férias, como alterar o número de hospedes, após ter enviado o pedido de reserva ?",
          answer: "Solicite a alteração diretamente ao proprietário ou agente pelo chat da reserva."
        },
        {
          question: "Num anúncio para férias, como solicitar extras no alojamento, após ter enviado o pedido de reserva ?",
          answer: "Envie uma mensagem ao proprietário informando os extras desejados."
        },
        {
          question: "Num anúncio para férias, como anular, após ter enviado o pedido de reserva ?",
          answer: "Acesse sua área de reservas e utilize a opção de cancelamento ou solicite diretamente ao proprietário."
        }
      ]
    },
    {
      title: "Conta e Cadastro",
      icon: <FaCreditCard />,
      description: "Perguntas sobre criação, acesso e gerenciamento de conta.",
      questions: [
        {
          question: "Como criar uma conta na Joviplanet de forma rápida e simples ?",
          answer: "Clique em 'Registrar', preencha os dados solicitados e siga as instruções enviadas por e-mail."
        },
        {
          question: "O que fazer se não conseguir criar conta ?",
          answer: "Verifique se todos os campos obrigatórios foram preenchidos corretamente. Se o problema persistir, entre em contato com o suporte."
        },
        {
          question: "O que fazer se me esqueci ou perdi a palavra passe ?",
          answer: "Na tela de login, clique em 'Esqueceu a senha?', informe seu e-mail e siga as instruções para redefinir a senha."
        },
        {
          question: "Como fechar a conta pessoal ?",
          answer: "Acesse as configurações da conta e selecione a opção para encerrar sua conta. Confirme a operação seguindo as instruções."
        },
        {
          question: "Como alterar e-mail e ou a palavra passe ?",
          answer: "Na área de cliente, vá em configurações de conta para alterar seu e-mail ou senha."
        },
        {
          question: "Os dados da minha conta pessoal são os mesmos para a faturação?",
          answer: "Sim, por padrão os dados são compartilhados, mas você pode editar informações específicas na área de faturação."
        }
      ]
    },
    {
      title: "Planos, Publicação e Gerenciamento de Anúncios",
      icon: <FaCreditCard />,
      description: "Tudo sobre planos, publicação, renovação e gerenciamento de anúncios.",
      questions: [
        {
          question: "Como obter uma fatura pela compra do meu plano ?",
          answer: (
            <span>
              Você pode consultar e descarregar a sua fatura na sua <strong>Conta Pessoal</strong> dentro do site.
              Caso prefira, também pode solicitar a fatura <strong>enviando um pedido através do formulário de contacto</strong> disponível em
              {' '}<a href="/contato">joviplanet.com/contato</a>.
            </span>
          )
        },
        {
          question: "Como posso anunciar na Joviplanet ?",
          answer: "Escolha um plano, cadastre-se e publique seu anúncio seguindo os passos da plataforma."
        },
        {
          question: "Quantas fotos é possível colocar por anúncio ?",
          answer: "O limite de fotos depende do plano contratado. Consulte os detalhes do seu plano."
        },
        {
          question: "Como modificar as fotos do meu anúncio ?",
          answer: "Acesse sua área de anúncios, selecione o anúncio desejado e utilize a opção de editar fotos."
        },
        {
          question: "Posso modificar os anúncios ao correr do mês ?",
          answer: "Sim, é possível editar seus anúncios a qualquer momento durante o período de vigência."
        },
        {
          question: "Posso alterar o valor indicado inicialmente no anúncio ?",
          answer: "Sim, basta editar o anúncio e atualizar o valor."
        },
        {
          question: "O que é uma área de cliente ?",
          answer: "É o espaço reservado para você gerenciar seus anúncios, planos, mensagens e dados pessoais."
        },
        {
          question: "Quanto tempo pode ficar um anúncio pendente ou arquivado na área de cliente ?",
          answer: "Anúncios pendentes ou arquivados permanecem visíveis na área de cliente até serem excluídos ou reativados."
        },
        {
          question: "Como publicitar/ativar um anúncio ?",
          answer: "Após cadastrar o anúncio, utilize o botão 'Ativar' na área de anúncios para publicá-lo."
        },
        {
          question: "O que fazer se não encontra o anúncio publicado ?",
          answer: "Verifique se o anúncio está ativo e se não há pendências de documentação. Caso contrário, entre em contato com o suporte."
        },
        {
          question: "Qual o período de publicação dos anúncios ?",
          answer: "O período depende do plano escolhido. Consulte as informações do seu plano na área de cliente."
        },
        {
          question: "Como fazer a renovação do anúncio ?",
          answer: "Na área de anúncios, selecione o anúncio e clique em 'Renovar'. Siga as instruções para pagamento se necessário."
        },
        {
          question: "Como fazer a renovação do plano ?",
          answer: "Na área de cliente, acesse planos e clique em 'Renovar plano'."
        },
        {
          question: "O limite do número de anúncio do plano excedeu o que fazer ?",
          answer: "Considere fazer upgrade de plano ou remover anúncios antigos para liberar espaço."
        }
      ]
    }
  ,
    {
      title: "Limpeza de Histórico do Navegador",
      icon: <FaQuestionCircle />,
      description: "Como limpar o histórico, cookies e cache nos principais navegadores.",
      questions: [
        {
          question: "Como fazer a limpeza do histórico do meu computador?",
          answer: (
            <div>
              <strong>GOOGLE CHROME</strong>
              <ul>
                <li>No canto superior direito da janela do Google Chrome, clique nos 3 pontinhos</li>
                <li>Selecionar, mais ferramentas</li>
                <li>Clique em Limpar dados de Navegação</li>
                <li>Clique em Avançadas, selecionar Histórico de Navegação, Cookies e imagens, ficheiros em Cache</li>
                <li>Verificar se não selecionou nada mais nesta lista, assim Palavras-Passe e dados automáticos não serão apagados</li>
                <li>Encerrar o Google Chrome e reiniciar o browser antes de navegar novamente em Joviplanet.com</li>
              </ul>
              <strong>MOZILA FIREFOX</strong>
              <ul>
                <li>No canto superior direito da janela do Firefox, clique nas 3 linhas</li>
                <li>Selecionar, Biblioteca</li>
                <li>Clique em Histórico e depois em Limpar histórico recente</li>
                <li>Selecionar somente em Cookies e Cache, assim as Palavras-Passe e os dados automáticos não serão apagados</li>
                <li>Após verificação, clique em OK/Limpar agora</li>
                <li>Encerrar o Firefox e reiniciar o browser antes de navegar novamente em Joviplanet.com</li>
              </ul>
              <strong>SAFARI</strong>
              <ul>
                <li>Ir a Definições</li>
                <li>Selecionar Safari</li>
                <li>Clique em Histórico e Dados de sites</li>
                <li>Selecionar somente em Cookies e Cache, assim as Palavras-Passe e os dados automáticos não serão apagados</li>
                <li>Após verificação, clique em Limpar</li>
                <li>Encerrar o Safari e reiniciar o browser antes de navegar novamente em Joviplanet.com</li>
              </ul>
              <strong>MICROSOFT EDGE</strong>
              <ul>
                <li>No canto superior direito da janela Da Microsoft Edge, clique nos 3 pontinhos</li>
                <li>Selecionar em Histórico e de seguida Limpar histórico</li>
                <li>Selecionar somente em Cookies e Cache, assim as Palavras-Passe e os dados automáticos não serão apagados</li>
                <li>Após verificação, clique em Limpar</li>
                <li>Encerrar o Edge e reiniciar o browser antes de navegar novamente em Joviplanet.com</li>
              </ul>
              <strong>INTERNET EXPLORER</strong>
              <ul>
                <li>Recomendação para que possa ter melhor uso na Navegação de Internet, utilizar GOOGLE CHROME, visto que Internet Explorer deixou de ser suportado pela Microsoft</li>
              </ul>
              <strong>Atenção:</strong> Esta recomendação não se aplica a todas as situações. Por vezes alguns problemas dos navegadores são resolvidos em modo JANELA ANÓNIMA.<br />
              No menu do browser do Google Chrome, escolha <strong>Nova Janela Sem Registo</strong>.<br />
              No menu do browser do Firefox, escolha <strong>Nova Janela Privada</strong> e no browser do Edge, escolha <strong>Janela InPrivate</strong>.
            </div>
          )
        }
      ]
    }
  ];

  const toggleSection = (index) => {
    setOpenSection(openSection === index ? null : index);
    setOpenQuestion(null);
  };

  const toggleQuestion = (sectionIndex, questionIndex) => {
    setOpenQuestion(openQuestion === `${sectionIndex}-${questionIndex}` ? null : `${sectionIndex}-${questionIndex}`);
  };

  const normalize = (value) => String(
    typeof value === 'string'
      ? value
      : (value && value.props && typeof value.props.children === 'string'
        ? value.props.children
        : value)
    || ''
  )
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  const splitTerms = (text) => normalize(text).split(/\s+/).filter(Boolean);

  const matchesContent = (terms, ...fields) => {
    const haystack = fields.map(normalize).join(' ');
    return terms.every(term => haystack.includes(term));
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value) {
      const terms = splitTerms(value);
      const firstSectionWithResults = faqSections.findIndex(section =>
        section.questions.some(q => matchesContent(terms, q.question, q.answer, section.title, section.description))
      );
      setOpenSection(firstSectionWithResults >= 0 ? firstSectionWithResults : null);
    } else {
      setOpenSection(null);
    }
    setOpenQuestion(null);
  };

  const filteredSections = searchTerm
    ? faqSections.map(section => ({
        ...section,
        questions: section.questions.filter(q => {
          const terms = splitTerms(searchTerm);
          return matchesContent(terms, q.question, q.answer, section.title, section.description);
        })
      })).filter(section => section.questions.length > 0)
    : faqSections;

  return (
    <div className="faq-page">
      <div className="faq-hero">
        <div className="hero-content">
        <h1>Perguntas Frequentes</h1>
          <p>Encontre a resposta para as suas dúvidas sobre a JoviPlanet</p>
        </div>
      </div>

      <div className="faq-content">
        <div className="faq-intro">
              <h2>Como podemos ajudar?</h2>
          <p>Selecione uma categoria abaixo ou pesquise a sua dúvida específica</p>
          <div className="search-container">
            <BsSearch className="search-icon" />
                <input
                  type="text"
              placeholder="Pesquisar pergunta..."
              value={searchTerm}
              onChange={handleSearch}
                  className="search-input"
                />
              </div>
            </div>

        {!searchTerm && (
          <div className="faq-categories">
            {faqSections.map((section, index) => (
  <div
    key={index}
    className="category-card"
    role="button"
    tabIndex={0}
    onClick={() => {
      setOpenSection(index);
      setTimeout(() => {
        if (sectionRefs.current[index]) {
          sectionRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }}
    onKeyPress={e => {
      if (e.key === 'Enter' || e.key === ' ') {
        setOpenSection(index);
        setTimeout(() => {
          if (sectionRefs.current[index]) {
            sectionRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }
    }}
    style={{ outline: 'none' }}
  >
    <div className="category-icon">{section.icon}</div>
    <h3>{section.title}</h3>
    <p>{section.description}</p>
  </div>
))}
          </div>
        )}


        <div className="faq-container">
          {filteredSections.map((section, sectionIndex) => (
            <div
              key={sectionIndex}
              className="faq-section"
              ref={el => sectionRefs.current[sectionIndex] = el}
            >
              <div 
                className={`section-header ${openSection === sectionIndex || (searchTerm && section.questions.length > 0) ? 'active' : ''}`}
                onClick={() => toggleSection(sectionIndex)}
              >
                <div className="section-header-content">
                  <span className="section-icon">{section.icon}</span>
                  <div>
                    <h2>{section.title}</h2>
                    <p>{section.description}</p>
                  </div>
                </div>
                <span className="toggle-icon"></span>
            </div>

              {(openSection === sectionIndex || (searchTerm && section.questions.length > 0)) && (
                <div className="questions-container">
                  {section.questions.map((item, questionIndex) => (
                    <div key={questionIndex} className="faq-item">
                      <div 
                        className={`question ${openQuestion === `${sectionIndex}-${questionIndex}` ? 'active' : ''}`}
                        onClick={() => toggleQuestion(sectionIndex, questionIndex)}
                      >
                        <h3>{item.question}</h3>
                        <span className="toggle-icon"></span>
                      </div>
                      {openQuestion === `${sectionIndex}-${questionIndex}` && (
                        <div className="answer">
                          <p>{item.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

          </div>

        <div className="faq-contact-info">
          <h2>Não encontrou o que procurava?</h2>
          <p>Nossa equipe está pronta para ajudar você</p>
          <Link to="/contato" className="contact-button">Entre em Contato</Link>
        </div>
      </div>
    </div>
  );
};

export default FAQ; 